import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { selectCarteiraDocumentos, irParaUploadDocumento } from '../carteiraDocumentosSlice';
import styles from './SelecionarDocumento.module.css';

interface TipoDocumento {
  key: string;
  titulo: string;
  subtitulo: string;
}

const SelecionarDocumento: React.FC = () => {
  const dispatch = useAppDispatch();
  const [documentoSelecionado, setDocumentoSelecionado] = useState<string>('');

  const dados = useAppSelector(selectCarteiraDocumentos);

  const tiposDocumento: TipoDocumento[] = [
    { key: '1', titulo: 'CIN', subtitulo: 'Carteira de Identidade Nacional' },
    { key: '2', titulo: 'CNH', subtitulo: 'Carteira Nacional de Habilitação' },
    { key: '3', titulo: 'e-Título', subtitulo: 'Título Eleitoral Digital' }
  ].filter(t => !dados.tiposDocumentoExistentes.includes(t.key));

  const handleContinuar = () => {
    if (!documentoSelecionado) return;
    const tipo = tiposDocumento.find(t => t.key === documentoSelecionado);
    dispatch(irParaUploadDocumento({
      tipoDocumento: documentoSelecionado,
      nomeDocumento: `${tipo?.titulo} - ${tipo?.subtitulo}`
    }));
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.integranteNome}>{dados.integranteNome}</h2>
      </div>

      <div className={styles.formContainer}>
        <h3 className={styles.pergunta}>Qual documento você quer inserir?</h3>
        
        <div className={styles.opcoesContainer}>
          {tiposDocumento.map((tipo) => (
            <label key={tipo.key} className={styles.opcaoLabel}>
              <input
                type="radio"
                name="tipoDocumento"
                value={tipo.key}
                checked={documentoSelecionado === tipo.key}
                onChange={() => setDocumentoSelecionado(tipo.key)}
                className={styles.radioInput}
              />
              <div className={styles.opcaoContent}>
                <span className={styles.opcaoTitulo}>{tipo.titulo}</span>
                <span className={styles.opcaoSubtitulo}>{tipo.subtitulo}</span>
              </div>
            </label>
          ))}
        </div>

        <div className={styles.infoFormatos}>
          <p className={styles.formatosTexto}>Formatos aceitos: PDF, PNG, JPG, JPEG</p>
          <p className={styles.tamanhoTexto}>Tamanho máximo: 2MB</p>
        </div>

        <div className={styles.botaoContainer}>
          <button 
            className={`${styles.botaoContinuar} ${!documentoSelecionado ? styles.botaoDesabilitado : ''}`}
            onClick={handleContinuar}
            disabled={!documentoSelecionado}
          >
            Continuar
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelecionarDocumento;
